var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMousePointer = function SvgMousePointer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1 25.48s-.08 0-.11-.02a.284.284 0 0 1-.18-.27l-.11-14.37c0-.16.13-.29.29-.29.08 0 .16.03.21.09l10.02 10.25c.12.11.12.3 0 .41-.06.06-.13.09-.21.09h0l-5.68-.06-4.02 4.09c-.06.06-.13.09-.21.09Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.51 21.5 3.26 7.97"
  })));
};
export default SvgMousePointer;